{
  "account": {
    "menu": {
      "trigger": "الحساب: {{name}}",
      "profile": "ملفي الشخصي",
      "vendorAccount": "حسابي",
      "language": "لغة العرض"
    },
    "nav": {
      "profile": "ملفي الشخصي"
    },
    "passwordField": {
      "show": "إظهار كلمة المرور"
    },
    "notRecorded": "غير مسجّل",
    "profile": {
      "title": "ملفي الشخصي",
      "subtitle": "حسابك في {{organisation}}",
      "aboutTitle": "معلوماتك",
      "aboutNote": "يحدّث مدير النظام في منشأتك بريدك الإلكتروني وهاتفك ومسمّاك الوظيفي.",
      "status": "حالة الحساب",
      "accessTitle": "منشأتك وصلاحياتك",
      "organisation": "المنشأة",
      "roles": "الأدوار",
      "noRoles": "لا توجد أدوار مسندة إليك",
      "scope": "نطاق عملك",
      "defaultNode": "وحدة الشراء الافتراضية",
      "timezone": "المنطقة الزمنية",
      "timezoneHint": "تحددها منشأتك",
      "accessNote": "مدير النظام في منشأتك وحده يغيّر أدوارك ونطاق عملك.",
      "otherOrganisation": "تعمل مع منشأة أخرى على فيدلِن؟ سجّل الخروج ثم سجّل الدخول من جديد، وستُعرض عليك حينها المنشآت التي تفتحها كلمة مرورك.",
      "securityTitle": "أمان تسجيل الدخول",
      "openSecurity": "فتح أمان تسجيل الدخول"
    },
    "preferences": {
      "title": "التفضيلات",
      "subtitle": "ما يمكنك تغييره بنفسك",
      "name": "الاسم",
      "nameHint": "كيف يظهر اسمك للآخرين في فيدلِن، مثلًا في الاعتمادات.",
      "nameAr": "الاسم بالعربية",
      "nameArHint": "يظهر لمن يستخدم فيدلِن بالعربية.",
      "locale": "لغة الرسائل والإشعارات",
      "localeHint": "اللغة التي يراسلك بها فيدلِن. أما مفتاح اللغة أعلى الشاشة فيغيّر ما يعرضه هذا الجهاز فقط.",
      "save": "حفظ التفضيلات",
      "saved": "حُفظت تفضيلاتك.",
      "unchanged": "لم يتغيّر شيء بعد.",
      "refusedTitle": "لم تُحفظ تفضيلاتك",
      "nameRequired": "أدخل اسمك.",
      "tooLong": "استخدم 150 حرفًا أو أقل."
    },
    "password": {
      "title": "كلمة المرور",
      "subtitle": "يغيّر هذا كلمة مرورك في {{organisation}} فقط.",
      "current": "كلمة المرور الحالية",
      "new": "كلمة المرور الجديدة",
      "newHintPlain": "استخدم حروفًا وأرقامًا.",
      "breachHint": "تُرفض كلمات المرور التي ظهرت في تسريبات بيانات معروفة.",
      "confirm": "تأكيد كلمة المرور الجديدة",
      "submit": "تغيير كلمة المرور",
      "changed": "تغيّرت كلمة مرورك. أي مكان آخر كان هذا الحساب مسجّلًا الدخول فيه يحتاج الآن إلى كلمة المرور الجديدة.",
      "refusedTitle": "لم تتغيّر كلمة مرورك",
      "currentRequired": "أدخل كلمة مرورك الحالية.",
      "newRequired": "أدخل كلمة مرور جديدة.",
      "confirmRequired": "أدخل كلمة المرور الجديدة مرة أخرى.",
      "mismatch": "كلمتا المرور الجديدتان غير متطابقتين.",
      "sameAsCurrent": "اختر كلمة مرور مختلفة عن الحالية.",
      "throttled": "محاولات كثيرة جدًا. انتظر بضع دقائق ثم حاول مرة أخرى.",
      "newHint_zero": "{{count}} حرف على الأقل، تجمع بين حروف وأرقام.",
      "tooShort_zero": "استخدم {{count}} حرف على الأقل.",
      "newHint_one": "حرف واحد على الأقل، تجمع بين حروف وأرقام.",
      "tooShort_one": "استخدم حرفًا واحدًا على الأقل.",
      "newHint_two": "حرفان على الأقل، تجمع بين حروف وأرقام.",
      "tooShort_two": "استخدم حرفين على الأقل.",
      "newHint_few": "{{count}} أحرف على الأقل، تجمع بين حروف وأرقام.",
      "tooShort_few": "استخدم {{count}} أحرف على الأقل.",
      "newHint_many": "{{count}} حرفًا على الأقل، تجمع بين حروف وأرقام.",
      "tooShort_many": "استخدم {{count}} حرفًا على الأقل.",
      "newHint_other": "{{count}} حرف على الأقل، تجمع بين حروف وأرقام.",
      "tooShort_other": "استخدم {{count}} حرف على الأقل.",
      "symbolHint": "أضف رمزًا.",
      "platformSubtitle": "يغيّر هذا كلمة مرور حساب مشغّل فيديلين فقط."
    },
    "vendor": {
      "title": "حسابي",
      "subtitle": "دخولك إلى بوابة المورد لدى {{buyer}}",
      "youTitle": "أنت",
      "companyTitle": "شركتك",
      "supplier": "الشركة",
      "buyer": "المنشأة التي تورّد لها",
      "openCompanyDetails": "فتح بيانات الشركة",
      "oneOrganisation": "هذا الدخول خاص بـ {{buyer}} فقط. أي منشأة أخرى تشتري منك على فيدلِن تمنحك دخولًا منفصلًا."
    },
    "platform": {
      "subtitle": "حسابك مشغّلًا لمنصة فيدلِن",
      "role": "الدور"
    }
  }
}
